module.exports = "/public/webpack/img/icon_help_categories_notifications_32e02f7e0bb18fa7bcb5b6bd22bf1a3380.png";